export default "__VITE_ASSET__0fd227be__"